import { useSyncExternalStore } from 'react'

/**
 * Is design v2 on for this document?
 *
 * Reads `<html data-design="v2">` (server-rendered by app/views/inertia.html.erb, re-synced on
 * Inertia navigation by lib/design-v2.ts) instead of page props, so ui primitives can use it
 * anywhere: inside Inertia pages, the booking entry, portals and tests without an Inertia
 * provider. A MutationObserver keeps every subscriber in step when the attribute flips.
 */
const ATTR = 'data-design'

function read(): boolean {
  if (typeof document === 'undefined') return false
  return document.documentElement.getAttribute(ATTR) === 'v2'
}

function subscribe(onChange: () => void): () => void {
  if (typeof MutationObserver === 'undefined') return () => {}
  const observer = new MutationObserver(onChange)
  observer.observe(document.documentElement, { attributes: true, attributeFilter: [ATTR] })
  return () => observer.disconnect()
}

export function useDesignV2(): boolean {
  return useSyncExternalStore(subscribe, read, () => false)
}
